// Generated by Melange

import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Input from "../../../html/Input.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__LoadingSpinner from "../../../atoms/LoadingSpinner.js";
import * as Buhta_cabinet__SlideOver from "../../../molecules/SlideOver.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__Bytes from "melange/bytes.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import PencilSvg from "static/icons/pencil.svg";

function make(id) {
  return function (onClose) {
    const func = Buhta_cabinet__Keychain.KeyService.view;
    const match = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, {
                        hd: "content",
                        tl: /* [] */0
                      }, id);
          }), undefined);
    const dispatch = match[1];
    const model = match[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), [id]);
    let tmp;
    if (typeof model === "string") {
      tmp = JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {
            className: "animate-fadeIn"
          });
    } else if (model.NAME === "Data") {
      const item = model.VAL;
      const content = item.content;
      if (content !== undefined) {
        const keyUsage = item.key_usage;
        const keySerialNo = item.key_serial_no;
        const p12 = Stdlib__Bytes.to_string(content.p12);
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Ключ",
                              className: "block text-sm font-medium leading-5 text-gray-700"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("a", {
                                    children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                          size: "s",
                                          kind: "default",
                                          onClick: (function (param) {
                                              
                                            }),
                                          children: "Скачать .p12"
                                        }),
                                    download: "" + keyUsage + "-" + keySerialNo + ".p12",
                                    href: "data:application/x-pkcs12;base64," + p12
                                  }),
                              className: "mt-1"
                            })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Пароль",
                              className: "block text-sm font-medium leading-5 text-gray-700"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                                    className: "form-input block w-full sm:text-sm sm:leading-5",
                                    value: content.password
                                  }),
                              className: "mt-1 relative rounded-md shadow-sm"
                            })
                      ],
                      className: "mt-6"
                    })
              ],
              className: "animate-fadeIn"
            });
      } else {
        tmp = "Контент ключа не подгрузился";
      }
    } else {
      console.log("grpc error", model.VAL);
      tmp = "Ошибка: " + "TODO: Unwrap grpc error";
    }
    return JsxRuntime.jsx(Buhta_cabinet__SlideOver.make, {
                title: {
                  TAG: /* Text */0,
                  _0: "Выгрузка ключа " + String(id)
                },
                actions: {
                  hd: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                        route: {
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Keychain */0,
                            _0: {
                              TAG: /* Keys */0,
                              _0: {
                                TAG: /* Edit */1,
                                _0: id
                              }
                            }
                          }
                        },
                        children: JsxRuntime.jsx(PencilSvg, {
                              className: "h-5 w-5 text-gray-400 hover:text-gray-500"
                            })
                      }),
                  tl: /* [] */0
                },
                onClose: onClose,
                children: tmp
              });
  };
}

function KeyItemPreview(Props) {
  return make(Props.id)(Props.onClose);
}

const make$1 = KeyItemPreview;

export {
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
